import * as React from 'react';
import { Box, Typography } from '@mui/material';

export const toDoSliderMarks = {
  desktop: {
    energy: [
      {
        value: 1,
        label: (
          <Box textAlign="center">
            <Typography variant="body2" fontWeight="bold">None</Typography>
            <Typography variant="caption" color="text.secondary">Can barely think</Typography>
          </Box>
        ),
      },
      {
        value: 2,
        label: (
          <Box textAlign="center">
            <Typography variant="body2" fontWeight="bold">Low Energy</Typography>
            <Typography variant="caption" color="text.secondary">Low focus available</Typography>
          </Box>
        ),
      },
      {
        value: 3,
        label: (
          <Box textAlign="center">
            <Typography variant="body2" fontWeight="bold">Slightly Off</Typography>
            <Typography variant="caption" color="text.secondary">Not fully there</Typography>
          </Box>
        ),
      },
      {
        value: 4,
        label: (
          <Box textAlign="center">
            <Typography variant="body2" fontWeight="bold">Normal</Typography>
            <Typography variant="caption" color="text.secondary">Feeling good!</Typography>
          </Box>
        ),
      },
      {
        value: 5,
        label: (
          <Box textAlign="center">
            <Typography variant="body2" fontWeight="bold">Energized</Typography>
            <Typography variant="caption" color="text.secondary">On a roll!</Typography>
          </Box>
        ),
      },
    ],
    time: [
      { value: 1, label: '5m' },
      { value: 2, label: '15m' },
      { value: 3, label: '30m' },
      { value: 4, label: '1h' },
      { value: 5, label: '2h+' },
    ],
  },
  mobile: {
    energy: [
      { value: 1, label: 'None' },
      { value: 2, label: 'Low' },
      { value: 3, label: 'Some' },
      { value: 4, label: 'Normal' },
      { value: 5, label: 'High' },
    ],
    time: [
      { value: 1, label: '5m' },
      { value: 2, label: '15m' },
      { value: 3, label: '30m' },
      { value: 4, label: '1h' },
      { value: 5, label: '2h+' },
    ],
  }
}

export const desktopSliderMarks = {
  energy: [
    {
      value: 1,
      label: 'Effortless',
    },
    {
      value: 2,
      label: 'Low Effort',
    },
    {
      value: 3,
      label: 'Some Effort',
    },
    {
      value: 4,
      label: 'Normal Effort',
    },
    {
      value: 5,
      label: 'High Effort',
    },
  ],
  priority: [
    {
      value: 1,
      label: 'Optional',
    },
    {
      value: 2,
      label: 'Low Priority',
    },
    {
      value: 3,
      label: 'Medium',
    },
    {
      value: 4,
      label: 'High Priority',
    },
    {
      value: 5,
      label: 'Critical',
    },
  ],
  time: [
    {
      value: 1,
      label: '5m',
    },
    {
      value: 2,
      label: '15m',
    },
    {
      value: 3,
      label: '30m',
    },
    {
      value: 4,
      label: '1h',
    },
    {
      value: 5,
      label: '2h+',
    },
  ],
};

export const mobileSliderMarks = {
  energy: [
    {
      value: 1,
      label: 'None',
    },
    {
      value: 2,
      label: 'Low',
    },
    {
      value: 3,
      label: 'Some',
    },
    {
      value: 4,
      label: 'Normal',
    },
    {
      value: 5,
      label: 'High',
    },
  ],
  priority: [
    {
      value: 1,
      label: 'Optional',
    },
    {
      value: 2,
      label: 'Low',
    },
    {
      value: 3,
      label: 'Medium',
    },
    {
      value: 4,
      label: 'High',
    },
    {
      value: 5,
      label: 'Critical',
    },
  ],
  time: desktopSliderMarks.time
};
